import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

export const normalizeLanguage = (value) => {
  if (typeof value !== "string") {
    return "hi";
  }

  const normalizedValue = value.trim().toLowerCase();
  if (normalizedValue === "hi" || normalizedValue.startsWith("hi")) {
    return "hi";
  }

  if (normalizedValue === "en" || normalizedValue.startsWith("en")) {
    return "en";
  }

  return "hi";
};

const LanguageContext = createContext({
  language: "hi",
  setLanguage: () => {},
});

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    if (typeof window === "undefined") {
      return "hi";
    }

    return normalizeLanguage(window.localStorage.getItem("imaancraze-language"));
  });

  useEffect(() => {
    if (typeof window === "undefined") return;

    const storedLanguage = normalizeLanguage(window.localStorage.getItem("imaancraze-language"));
    if (storedLanguage === "en" || storedLanguage === "hi") {
      setLanguage(storedLanguage);
      return;
    }

    const browserLanguage = normalizeLanguage(window.navigator.language || "");
    if (browserLanguage === "en") {
      setLanguage("en");
    } else {
      setLanguage("hi");
    }
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") return;

    window.localStorage.setItem("imaancraze-language", language);
    document.documentElement.lang = language === "en" ? "en" : "hi";
  }, [language]);

  const value = useMemo(() => ({ language, setLanguage }), [language]);

  return (
    <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
